<div *ngIf="loadingCompleted">
    <div
        class="p-4"
        *ngIf="testConfirmationEmail?.length < 1; else emailAvailable"
    >
        <p class="alert alert-danger">Unable to load the page. Please contact Paragon.</p>
    </div>
    <ng-template #emailAvailable>
        <div class="printSection">
            <div class="print-icon row">
                <button
                    (click)="print()"
                    type="button"
                ><i class="fa fa-print fa-2x"></i><strong> Print</strong></button>
            </div>
            <br />
            <br />
            <div
                class="email"
                [innerHTML]="testConfirmationEmail | safe: 'html'"
            >
            </div>
        </div>
    </ng-template>
</div>
